<template>
  <div style="width:1000px;">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Pending</h2></app-cells>
      <v-client-table
        :data="table_pending.items"
        :columns="table_pending.columns"
        :options="table_pending.options"
        class="table-default"
      >
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-end', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #supplier="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'reservation-payment-requests-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.supplier.legal_name }}
            </router-link>
          </div>
        </template>
        <template #amount="{ row }">{{ amountFormat(row.amount) }}</template>
      </v-client-table>
      <app-cells><h2 class="title">Completed</h2></app-cells>
      <v-client-table
        :data="table_completed.items"
        :columns="table_completed.columns"
        :options="table_completed.options"
        class="table-default"
        :class="{ 'table-default--loading': table_completed_preloader }"
      >
        <template #h__completed_by><div class="table-default__left">Completed by</div></template>
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #completed_by="{ row }">
          <div class="table-default__left">
            <div v-if="row.completed_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.completed_by?.crop?.crop_url)" alt=""
                  v-tooltip="{ content: row.completed_by.full_name, placement: 'top-end', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.completed_at) }}
            </div>
          </div>
        </template>
        <template #supplier="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'reservation-payment-requests-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.supplier.legal_name }}
            </router-link>
          </div>
        </template>
        <template #amount="{ row }">{{ amountFormat(row.amount) }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationCompleted"
            v-if="pagination_completed.pages > 1"
            v-model="pagination_completed.page"
            :page-count="pagination_completed.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_completed.count" :count="table_completed.items.length" :page="pagination_completed.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getReservationsPaymentRequestsList } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'ReservationPaymentRequests',
  data() {
    return {
      is_loaded: false,
      table_pending: {
        items: [],
        columns: ['created', 'supplier', 'amount'],
        options: {
          headings: {
            created: 'Created by',
            supplier: 'Supplier',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_completed_preloader: false,
      table_completed: {
        items: [],
        columns: ['completed_by', 'supplier', 'amount'],
        options: {
          headings: {
            completed_by: 'Completed by',
            supplier: 'Supplier',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_completed: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    Promise.all([
      this.fetchItemsPending(),
      this.fetchItemsCompleted(),
    ])
      .then(() => {
        this.is_loaded = true
      })
  },
  methods: {
    async fetchItemsPending() {
      const response = await getReservationsPaymentRequestsList({completed: false})
      this.table_pending.items = response.data
    },
    async fetchItemsCompleted() {
      this.table_completed_preloader = true
      const response = await getReservationsPaymentRequestsList({
        completed: true,
        ordering: '-completed_at',
        page_size: 20,
        page: this.pagination_completed.page
      })
      this.table_completed.items = response.data.results
      this.pagination_completed.pages = response.data.pages
      this.pagination_completed.count = response.data.count
      this.table_completed_preloader = false
    },
    onClickPaginationCompleted(page) {
      this.pagination_completed.page = page
      this.fetchItemsCompleted()
    },
    formatDateTime(date) {
      return date ? format(parseISO(date), 'dd MMMM yyyy HH:mm') : '-'
    },
    amountFormat(amount) {
      return amount ? `${new Intl.NumberFormat('ru-RU').format(amount)} $` : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>